<template>
  <div class="page">

    <div id="container-purchase-summary" class="container valign-wrapper" :style="{ 'border-color': $store.getters.getData.color1 }">
      <div class="row">
        <app-loader v-if="loading"></app-loader>
        <div v-else>

          <div class="row wrapper">
            <div class="col s12 m4 center-align">
              <img :src="$store.getters.getData.logo" class="right-center">
            </div>

            <div class="col s12 m8">

              <div v-if="($store.getters.purchase.type === 'cart' || $store.getters.purchase.type === 'pro') && $store.getters.getData.type_shop !== 'INT' " class="box-data">
                <h5>{{ $t("PURCHASE.TITLE-ADDRESS") }}</h5>
                <ul v-if="user">
                  <li>{{user.first_name}} {{user.last_name}}</li>
                  <li>{{user.address}},  {{user.city}} {{user.postal_code }}</li>
                  <li v-if="user.country2">{{user.province}} {{user.country2.country}}</li>
                  <li v-else>{{user.province}}</li>
                </ul>
                <span v-else style="color: #ef5350;">{{ $t("PURCHASE.NO-ADDRESS") }}</span>
              </div>

              <div class="box-data" style="margin-top: 25px;">
                <h5>{{ $t("PURCHASE.TITLE") }}</h5>
                <ul>
                  <li v-if="purchase.subtotal != purchase.total">
                    {{ $t("PURCHASE.SUBTOTAL") }}: <span>{{purchase.subtotal | currency}}</span>
                  </li>
                  <li v-if="purchase.tax">
                    {{ $t("PURCHASE.TAXES") }}: <span>{{purchase.tax | currency}}</span>
                  </li>
                  <li v-if="purchase.costs">
                    {{ $t("PURCHASE.COSTS") }}: <span>{{purchase.costs | currency}}</span>
                  </li>
                  <li v-if="purchase.total" style="font-weight: bold;">
                    {{ $t("PURCHASE.TOTAL") }}: <span>{{ total | currencyFormatter(currency)}}</span>
                  </li>
                </ul>
              </div>

              <div class="col s12 m6 offset-m3 center-align wrapper-card-data">
                <div v-if="cards" class="col s12 valign-wrapper">
                  <div class='col s2' :class="{ 'icon-disabled': isPrev }" v-on:click="prev"><icon name="caret-left" scale='6' class='icon'></icon></div>
                  <div class="col s8" v-on:keyup.left="prev" v-on:keyup.right="next">
                    <div class="image a16by9" :class="'img-' + selectedCard.brand.replace(/\s/g, '')">
                      <div class="card-data">
                        <span class="add text-black-shadow">{{selectedCard.name}}</span>
                        <span class="last4 text-black-shadow">**** **** **** {{selectedCard.last4}}</span>
                        <div class="exp">
                          <span class="text-black-shadow">{{selectedCard.exp_month}}/{{selectedCard.exp_year}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class='col s2' :class="{ 'icon-disabled': isNext }" v-on:click="next"><icon name="caret-right" scale='6' class='icon'></icon></div>
                </div>
                <div class="col s12" style="margin-top: 1.6rem;">
                  <div ref="error" class="error">
                    <span class="message"></span>
                  </div>
                </div>
                <a v-on:click="showModalPIN" v-on:keyup.enter="showModalPIN" class="waves-effect waves-light btn-large focusable" tabindex="-1">
                  <span v-if='!waiting'>{{ $t("PURCHASE.CHECKOUT") }}</span>
                  <icon v-else name="sync" spin  scale='1.8'></icon>
                </a>
              </div>

            </div>
          </div>

          <Modal v-if="showModal" @close="closeModal">
            <p v-if="showModal === 'dialog'" slot="body">{{$t('SHOP.SUCCESSFUL')}}</p>

            <p v-if="showModal === 'missingData'" slot="body">
              {{dialogText}}
              <a  class="url" target="_blank" :href="url">{{url}}</a>
            </p>

            <p v-if="showModal === 'PIN'" slot="header">{{$t('CONTENT-DETAIL.MODAL-PIN-TITLE')}}</p>
            <form v-if="showModal === 'PIN'" slot="body" ref="form" @submit="checkPIN" onsubmit="return false;">
              <input ref="pin" type="password" class="modal-focusable" minlength="4" maxlength="4" v-model='pin' required>
              <div ref="errorForm" class="error">
                <span class="message"></span>
              </div>
            </form>
            <a v-if="showModal === 'PIN'" slot="footer"  v-on:click="checkPIN" v-on:keyup.enter="checkPIN" class="waves-effect waves-light btn-large modal-focusable" tabindex="-1">{{ $t("GENERAL.ACCEPT") }}</a>
          </Modal>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Fingerprint2 from 'fingerprintjs2'
import Bus from '@/components/ControlBus'
import SpatialNavigation from 'js-spatial-navigation'
import Modal from '@/components/Modal'
import Loader from '@/components/Loader'
import List from '@/components/List'
import { enviroment } from '@/utils/constants'
import { setLocation, getLocation } from '@/utils/helper-functions'
const auth = require('@/services/auth.js')
const contentsService = require('@/services/contents.js')
const productsService = require('@/services/products.js')

export default {
  name: 'PurchaseSummary',
  components: { 'app-loader': Loader, 'app-list': List, Modal },
  data () {
    return {
      loading: true,
      purchase: false,
      cards: false,
      selectedCard: false,
      waiting: false,
      device: null,
      showModal: false,
      pin: '',
      user: null,
      dialogText: ''
    }
  },
  beforeCreate: function () {
    document.querySelector('body').style.overflowY = 'hidden'
  },
  created: function () {
    if (this.$store.getters.user && this.$store.getters.purchase) {
      if (this.$store.getters.purchase.type === 'cat' || this.$store.getters.purchase.type === 'cnt') {
        // compra contenidos
        contentsService.purchaseSumary(this.$store.getters.purchase.id, this.$store.getters.purchase.type, this.$store.getters.purchase.price).then(response => {
          this.purchase = response.data
          // validamos medios de pago / datos
          this.checkData()
        })
      } else if (this.$store.getters.purchase.type === 'cart') {
        // compra carrito
        if (this.$store.getters.getData.type_shop === 'A2C') {
          // tienda API2CART
          this.checkData()
        } else {
          productsService.purchaseSumary({total: this.$store.getters.purchase.total}).then(response => {
            this.purchase = response.data
            // validamos medios de pago / datos
            this.checkData()
          })
        }
      } else if (this.$store.getters.purchase.type === 'pro') {
        // compra directa producto
        this.checkData()
      }
    } else { this.$router.go(-1) }
  },
  mounted: function () {
    // control keys
    Bus.$on('key-back', this.keyBack)
    Bus.$on('key-left', this.prev)
    Bus.$on('key-right', this.next)
  },
  methods: {
    initControls () {
      this.SN = SpatialNavigation.add({selector: '#container-purchase-summary .focusable', restrict: 'self-only'})
      SpatialNavigation.makeFocusable(this.SN)

      SpatialNavigation.focus(this.SN)
      SpatialNavigation.resume()
    },
    checkData: function () {
      let missingData = false
      axios.all([auth.getCards(), auth.getUser()])
        .then(axios.spread((dataCards, dataUser) => {
          // cards
          if (dataCards.data.results.length) {
            this.selectedCard = dataCards.data.results[0]
            this.cards = dataCards.data.results
          } else { missingData = true }

          // address
          if (this.$store.getters.purchase.type === 'cart' || this.$store.getters.purchase.type === 'pro') {
            if (this.addressCompleted(dataUser.data.results[0])) {
              this.user = dataUser.data.results[0]
            } else { missingData = true }
          }

          // faltan datos (cards o address)
          if (missingData) {
            this.loading = false
            if (this.$store.getters.purchase.type === 'cat' || this.$store.getters.purchase.type === 'cnt') {
              this.dialogText = this.$i18n.tc('PURCHASE.MISSINGDATA-CARDS', this.$store.getters.getData.is_app_mobile)
            } else {
              this.dialogText = this.$i18n.tc('PURCHASE.MISSINGDATA-FULL', this.$store.getters.getData.is_app_mobile)
            }
            this.showModal = 'missingData'
          } else {
            this.setOrder()
          }
        }))
    },
    setOrder: function () {
      if (this.$store.getters.getData.type_shop === 'A2C') {
        // compra api2cart
        if (this.$store.getters.purchase.type === 'pro') {
          productsService.setOrderA2C(this.$store.getters.purchase.params).then(response => {
            productsService.getOrderA2C({order_id: response.data.order_id}).then(response => {
              // datos para enviar al finalizr compra
              this.orderId = response.data.order_id
              this.amount = response.data.totals.total

              this.loading = false
              this.purchase = {
                order_id: response.data.order_id,
                subtotal: response.data.total.subtotal_ex_tax,
                costs: response.data.total.shipping_ex_tax,
                total: response.data.total.total
              }
            })
          })
        } else {
          // carrito
          let data = { 'order_payment_method': 'Pago desde plataforma externa de TV' }
          productsService.cartProcessA2C(data).then(response => {
            productsService.getOrderA2C({order_id: response.data.order_id}).then(response => {
              // datos para enviar al finalizr compra
              this.orderId = response.data.order_id
              this.amount = response.data.totals.total

              this.loading = false
              this.purchase = {
                order_id: response.data.order_id,
                subtotal: response.data.total.subtotal_ex_tax,
                costs: response.data.total.shipping_ex_tax,
                total: response.data.total.total
              }
            })
          })
        }
      } else {
        // compra interna
        if (this.$store.getters.purchase.type === 'pro') {
          let data = {
            id: this.$store.getters.purchase.id,
            id_feature: this.$store.getters.purchase.id_feature,
            price: this.$store.getters.purchase.price,
            quantity: this.$store.getters.purchase.quantity
          }
          productsService.purchaseSumary(data).then(response => {
            this.purchase = response.data
            this.loading = false
            setTimeout(() => { this.initControls() }, 0)
          })
        } else {
          // contenido, categoría y carrito
          this.loading = false
        }
      }
    },
    addressCompleted: function (user) {
      if (this.$store.getters.getData.type_shop === 'INT') {
        return true
      }

      // facturable
      if (this.$store.getters.getData.is_invoice) {
        return (
          user.first_name &&
          user.last_name &&
          user.address &&
          user.city &&
          user.province &&
          user.postal_code &&
          user.nif
        )
      }

      // no facturable
      return (
        user.first_name &&
        user.last_name &&
        user.address &&
        user.city &&
        user.province &&
        user.postal_code
      )
    },
    showModalPIN: function () {
      if (!this.waiting) {
        this.pin = ''
        this.showModal = 'PIN'
      }
    },
    checkPIN () {
      if (this.$refs.form.checkValidity()) {
        SpatialNavigation.pause()
        this.$refs.errorForm.classList.remove('visible')

        auth.getUser().then(response => {
          if (parseInt(this.pin) === response.data.results[0].pin) {
            this.showModal = false
            SpatialNavigation.focus(this.SN)
            SpatialNavigation.resume()
            this.makePurchase()
          } else {
            this.pin = ''
            this.$refs.errorForm.querySelector('.message').innerText = this.$i18n.t('CONTENT-DETAIL.MODAL-PIN-ERROR')
            this.$refs.errorForm.classList.add('visible')
            SpatialNavigation.resume()
            this.$refs.pin.focus()
          }
        }).catch((error) => {
          console.error(error.response)
          this.pin = ''
          this.$refs.errorForm.querySelector('.message').innerText = this.$i18n.t('CONTENT-DETAIL.MODAL-PIN-ERROR')
          this.$refs.errorForm.classList.add('visible')
          SpatialNavigation.resume()
          this.$refs.pin.focus()
        })
      }
    },
    makePurchase () {
      if (!this.waiting) {
        SpatialNavigation.pause()
        this.waiting = true
        this.$refs.error.classList.remove('visible')
        // creamos u obtenemos device
        this.device = this.$store.getters.device
        if (this.device) {
          this.serverPurchase()
        } else {
          new Fingerprint2().get((uuid) => {
            this.device = {
              available: true,
              platform: 'browser',
              uuid: uuid
            }
            this.$store.commit('setDevice', this.device)
            this.getGeolocation()
          })
        }
      }
    },
    closeModal: function (event) {
      if (this.showModal === 'dialog' || this.showModal === 'missingData') {
        this.redirect()
      }
      this.showModal = false
      SpatialNavigation.focus(this.SN)
    },
    getGeolocation () {
      let location = getLocation(this.$store.getters.getData.is_zones)
      if (location) {
        this.setDevice(location.lat, location.lon)
      } else {
        if (navigator.geolocation && !window.webOS) {
          // obtenemos geolocalización (LG no lo permite)
          let options = {
            enableHighAccuracy: false,
            timeout: 8000,
            maximumAge: Infinity
          }
          navigator.geolocation.getCurrentPosition(
            (position) => {
              setLocation({lat: position.coords.latitude, lon: position.coords.longitude})
              this.setDevice(position.coords.latitude, position.coords.longitude)
            },
            () => { this.setDevice(0, 0) },
            options)
        } else {
          this.setDevice(0, 0)
        }
      }
    },
    setDevice (lat, long) {
      lat = parseFloat(lat).toFixed(10)
      long = parseFloat(long).toFixed(10)

      if (this.device.platform === 'tv-webos' || this.device.platform === 'sectv-tizen') {
        // TV (Lg or Samsung)
        let type = ''
        if (this.device.platform === 'tv-webos') {
          type = 'LG'
        } else if (this.device.platform === 'sectv-tizen') {
          type = 'SAM'
        }

        let name = this.device.manufacturer + '/' + this.device.model
        let uuid = this.device.uuid
        let system = this.device.platform + '/' + this.device.version

        // guardamos u obtenemos device
        auth.setDevice(lat, long, name, type, uuid, system).then(response => {
          this.serverPurchase()
        }).catch((error) => {
          console.error(error)
          SpatialNavigation.resume()
          this.waiting = false
        })
      } else if (this.device.platform === 'browser') {
        // browser
        let userAgent = navigator.userAgent.substring(0, 150)
        // guardamos u obtenemos device
        auth.setDevice(lat, long, 'Browser', 'WEB', this.device.uuid, userAgent).then(response => {
          this.serverPurchase()
        }).catch((error) => {
          console.error(error)
          SpatialNavigation.resume()
          this.waiting = false
        })
      } else { console.error('Unknown Device') }
    },
    serverPurchase () {
      if (this.$store.getters.getData.type_shop === 'A2C') {
        // compra api2cart
        let data = {
          'order_id': this.orderId,
          'card_id': this.selectedCard.id,
          'amount': this.amount
        }

        productsService.makePurchaseA2C(data).then(response => {
          this.showModal = 'dialog'
        }).catch(() => {
          SpatialNavigation.resume()
          this.waiting = false
          this.$refs.error.classList.add('visible')
          this.$refs.error.querySelector('.message').innerText = this.$i18n.t('PURCHASE.ERROR')
        })
      } else {
        // compra interna
        if (this.$store.getters.purchase.type === 'cat' || this.$store.getters.purchase.type === 'cnt') {
          // compra contenidos
          contentsService.makePurchase(this.$store.getters.purchase.id, this.$store.getters.purchase.inna, this.$store.getters.device.uuid, this.selectedCard.id, this.$store.getters.purchase.type, this.purchase.total).then(response => {
            this.showModal = 'dialog'
          }).catch(() => {
            SpatialNavigation.resume()
            this.waiting = false
            this.$refs.error.classList.add('visible')
            this.$refs.error.querySelector('.message').innerText = this.$i18n.t('PURCHASE.ERROR')
          })
        } else if (this.$store.getters.purchase.type === 'cart') {
          // compra carrito
          let data = {
            pay_type: 'STR',
            card_id: this.selectedCard.id,
            total: this.purchase.total,
            device: this.$store.getters.device.uuid
          }
          productsService.makePurchase(data).then(response => {
            this.showModal = 'dialog'
          }).catch(() => {
            SpatialNavigation.resume()
            this.waiting = false
            this.$refs.error.classList.add('visible')
            this.$refs.error.querySelector('.message').innerText = this.$i18n.t('PURCHASE.ERROR')
          })
        } else if (this.$store.getters.purchase.type === 'pro') {
          // compra directa producto
          let data = {
            pay_type: 'STR',
            product: this.$store.getters.purchase.id,
            features: this.$store.getters.purchase.features,
            quantity: this.$store.getters.purchase.quantity,
            card_id: this.selectedCard.id,
            total: this.purchase.total,
            device: this.$store.getters.device.uuid
          }

          productsService.makeDirectPurchase(data).then(response => {
            this.showModal = 'dialog'
          }).catch(() => {
            SpatialNavigation.resume()
            this.waiting = false
            this.$refs.error.classList.add('visible')
            this.$refs.error.querySelector('.message').innerText = this.$i18n.t('PURCHASE.ERROR')
          })
        }
      }
    },
    redirect () {
      // abrimos contenido store
      if (this.$store.getters.purchase.type === 'cnt' && parseInt(this.$store.getters.purchase.id) === this.$store.getters.contentStackTop.id) {
        this.$store.getters.contentStackTop.is_paid = true
      }
      if (this.$store.getters.purchase.type === 'cart') {
        this.$router.replace({name: 'shop'})
      } else {
        this.$router.go(-1)
      }
    },
    prev () {
      if (this.cards[this.cards.indexOf(this.selectedCard) - 1]) {
        this.selectedCard = this.cards[this.cards.indexOf(this.selectedCard) - 1]
      }
    },
    next () {
      if (this.cards[this.cards.indexOf(this.selectedCard) + 1]) {
        this.selectedCard = this.cards[this.cards.indexOf(this.selectedCard) + 1]
      }
    },
    keyBack: function () {
      if (!this.waiting && !this.showModal) {
        this.$router.go(-1)
      }
    }
  },
  computed: {
    url: function () {
      if (this.$store.getters.getData.login_url) {
        return this.$store.getters.getData.login_url
      }
      let env = enviroment
      if (enviroment === 'api' || enviroment === 'api-pinko') { env = 'portal' }
      return 'https://' + env + '.interactvty.com/tv/' + this.$store.getters.getData.name + '/'
    },
    isPrev () { return !this.cards[this.cards.indexOf(this.selectedCard) - 1] },
    isNext () { return !this.cards[this.cards.indexOf(this.selectedCard) + 1] },
    total: function () {
      return (this.$store.getters.user.country2 && (this.$store.getters.purchase.type === 'cat' || this.$store.getters.purchase.type === 'cnt')) ? this.purchase.total * this.$store.getters.user.exchange : this.purchase.total
    },
    currency: function () {
      return (this.$store.getters.user.country2 && (this.$store.getters.purchase.type === 'cat' || this.$store.getters.purchase.type === 'cnt')) ? this.$store.getters.user.country2.currency : this.$store.getters.getData.currency
    }
  },
  beforeDestroy: function () {
    this.$store.commit('setPurchase', null)
    Bus.$off('key-back', this.keyBack)
    Bus.$off('key-left', this.prev)
    Bus.$off('key-right', this.next)
    if (this.SN) SpatialNavigation.remove(this.SN)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
.container
  min-width: 95vw
  min-height: 95vh
  // padding: 2rem
  margin-top: 2rem
  background-color: #ffffff
  border-radius: 2px
  color: #424242
  // box-sizing: content-box
  border-top: .5rem solid black

  .row
    min-height: 100%
    margin: 0!important

    .wrapper
      min-width: 95vw
      min-height: 90vh
      padding: 0px 2rem 0px 2rem;

      img
        max-width: 75%
        height: auto
        margin-top: 1rem

      .box-data
        box-shadow: 0 10px 16px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19) !important;
        padding: 5px 20px 5px 20px;
        border-radius: .25rem

      h5
        font-size: 2rem

      li
        font-size: 1.3rem
        line-height: 1.3

        span
          float: right

.url
  font-weight: bold
  color: inherit;

// TARJETAS
.wrapper-card-data
  position: relative
  user-select: none
  margin-top: 1.5rem;

  .icon-disabled
    opacity: 0.6;
    cursor: not-allowed;

  .icon
    cursor: pointer

  .image
    background-image: url('../../assets/images/cards/default.jpg')
    background-position: center center
    background-repeat: no-repeat
    background-size: cover
    border-radius: 5px 5px 5px 5px!important

  .img-Visa
    background-image: url('../../assets/images/cards/visa.jpg')

  .img-MasterCard
    background-image: url('../../assets/images/cards/mastercard.jpg')

  .img-AmericanExpress
    background-image: url('../../assets/images/cards/american.jpg')

  .card-data
    position: absolute
    top: 0
    width: 100%
    height: 100%
    display: flex
    display: -webkit-flex
    flex-direction: column
    justify-content: center
    align-items: center
    color: #424242

    .add, .last4
      font-size: 1.3rem

    .exp
      font-size: 1.2rem
      position: absolute
      bottom: 0
      right: 0
      margin-right: 1rem
      margin-bottom: 1rem

  a
    margin-top: .1rem

#form-pin
  margin-top: 10rem
  // clear: both;
  max-width: 100%

  a
    float: right;
    margin-top: 1rem;

.error
  visibility: hidden
  color: #ef5350

.visible
  visibility: visible
</style>



// WEBPACK FOOTER //
// src/pages/site/PurchaseSummary.vue